import { IDataFlowExpression } from '../interfaces';
import { IDataFlowDatasetSettings } from './IDataFlowDatasetSettings';

export enum FILEMODE {
    FILE,
    WILDCARD
}

export interface IFileBasedSettings extends IDataFlowDatasetSettings {
    folderPath: IDataFlowExpression;
    container: IDataFlowExpression;
    fileName: IDataFlowExpression;
    fileMode: FILEMODE;
}
